// The deal's fields, read-only, as entries of the caller's description list: on the deal's page
// for a reader or a deal that takes no edit, and beneath the path for what Proposal holds once
// the deal has passed it (StageHolds.jsx). With the deal flow on, the terms it adds join them
// (dealTerms.js).

import { counterpartyLabel, directionLabel, formatMoney, formatPrice } from './dealForm.js';
import { dealTerms } from './dealTerms.js';

export default function DealFieldList({ fields, flow, labels, vocabulary }) {
  return (
    <>
      <Field label="Auremin" value={directionLabel(fields.direction)} />
      <Field label={counterpartyLabel(fields.direction)} value={fields.counterparty}
             render={renderCounterparty} />
      <Field label="Product" value={fields.product} />
      <Field label="Trader" value={fields.trader} />
      <Field label="Volume" value={fields.quantity} render={(q) => `${q.amount} ${q.unit}`} />
      <Field label="Price" value={fields.price}
             render={(price) => formatPrice(price, fields.quantity?.unit)} />
      <Field label="Deal value" value={fields.value} render={formatMoney} />
      {flow && dealTerms(fields, labels, vocabulary).map(([label, value]) => (
        <Field key={label} label={label} value={value} />
      ))}
      <Field label="Notes" value={fields.notes} />
    </>
  );
}

// An empty field is omitted rather than shown blank: a page of empty labels reads as broken, and
// a deal is expected to be incomplete.
export function Field({ label, value, render }) {
  if (value === null || value === undefined || value === '') return null;
  const rendered = render ? render(value) : value;
  if (!rendered) return null;

  return (
    <>
      <dt>{label}</dt>
      <dd>{rendered}</dd>
    </>
  );
}

function renderCounterparty(reference) {
  if (reference.counterparty_id) return reference.display_name;
  return (
    <span className="unresolved" title="Not yet a counterparty record">
      {reference.display_name}
    </span>
  );
}
